import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

interface Props {
  value: number;
}

const Wrapper = styled.div<{ color: string }>`
  display: flex;
  margin-top: 10px;
  color: ${(props) => props.color};
`;

const Num = styled.div`
  margin-left: 5px;
`;

const NegtiveConvertionIcon = styled.div`
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;

  border-top: 10px solid #e17141;
  margin-top: 1px;
`;
const PositiveConvertionIcon = styled.div`
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;

  border-bottom: 10px solid #2ca09c;
`;

const calculateColor = (value: number) => {};

const ForecastProjection: React.FC<Props> = (props) => {
  const [value, setValue] = useState(Math.abs(props.value));
  const [isIncrease, setIsIncrease] = useState(props.value > 0);

  useEffect(() => {
    setValue(Math.abs(props.value));
    setIsIncrease(props.value >= 0);
  }, [props.value]);

  return (
    <Wrapper
      color={
        props.value == 0 ? '#000000' : props.value >= 0 ? '#2ca09c ' : '#e17141'
      }
    >
      {(props.value === 0 || isIncrease) && <PositiveConvertionIcon />}
      {(props.value === 0 || !isIncrease) && <NegtiveConvertionIcon />}
      <Num>{value}%</Num>
    </Wrapper>
  );
};

export default ForecastProjection;
